/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAppointmentResponse } from './UserAppointmentResponse';
import {
    UserAppointmentResponseFromJSON,
    UserAppointmentResponseFromJSONTyped,
    UserAppointmentResponseToJSON,
    UserAppointmentResponseToJSONTyped,
} from './UserAppointmentResponse';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
    PageableToJSONTyped,
} from './Pageable';

/**
 * 
 * @export
 * @interface PaginatedUserAppointmentsResponse
 */
export interface PaginatedUserAppointmentsResponse {
    /**
     * 
     * @type {Pageable}
     * @memberof PaginatedUserAppointmentsResponse
     */
    pageable: Pageable;
    /**
     * The amount of rows in total
     * @type {number}
     * @memberof PaginatedUserAppointmentsResponse
     */
    totalRowCount: number;
    /**
     * The rows in the current page
     * @type {Array<UserAppointmentResponse>}
     * @memberof PaginatedUserAppointmentsResponse
     */
    rows: Array<UserAppointmentResponse>;
}

/**
 * Check if a given object implements the PaginatedUserAppointmentsResponse interface.
 */
export function instanceOfPaginatedUserAppointmentsResponse(value: object): value is PaginatedUserAppointmentsResponse {
    if (!('pageable' in value) || value['pageable'] === undefined) return false;
    if (!('totalRowCount' in value) || value['totalRowCount'] === undefined) return false;
    if (!('rows' in value) || value['rows'] === undefined) return false;
    return true;
}

export function PaginatedUserAppointmentsResponseFromJSON(json: any): PaginatedUserAppointmentsResponse {
    return PaginatedUserAppointmentsResponseFromJSONTyped(json, false);
}

export function PaginatedUserAppointmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUserAppointmentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pageable': PageableFromJSON(json['pageable']),
        'totalRowCount': json['totalRowCount'],
        'rows': ((json['rows'] as Array<any>).map(UserAppointmentResponseFromJSON)),
    };
}

export function PaginatedUserAppointmentsResponseToJSON(json: any): PaginatedUserAppointmentsResponse {
    return PaginatedUserAppointmentsResponseToJSONTyped(json, false);
}

export function PaginatedUserAppointmentsResponseToJSONTyped(value?: PaginatedUserAppointmentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageable': PageableToJSON(value['pageable']),
        'totalRowCount': value['totalRowCount'],
        'rows': ((value['rows'] as Array<any>).map(UserAppointmentResponseToJSON)),
    };
}

